import { CarIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { EngineService } from '@/services/engine/engine-service';
import type { Vehicle } from '@/types/vehicle';
import { ThumbnailWithPreview } from '../ThumbnailWithPreview';

interface SelectedVehicleProps {
    vehicle: Vehicle;
    sectionLabel?: string;
}

export function SelectedVehicle({
    vehicle,
    sectionLabel,
}: SelectedVehicleProps) {
    const { t } = useTranslation(I18nNamespace.DIRECTORY);

    const label = sectionLabel ?? t('mergeVehicleModal.selectedVehicle');
    const displayName = vehicle.name ?? t('mergeVehicleModal.unnamedVehicle');
    const imageUrl = vehicle.lastEventId
        ? EngineService.getEventThumbnailUrl(vehicle.lastEventId)
        : (vehicle.thumbnailUrl ?? null);

    return (
        <div className="flex flex-col gap-3 rounded-lg bg-grey-600 px-3 py-3">
            <span className="text-sm text-grey-300">{label}</span>
            <div className="flex items-center gap-3 rounded-md bg-grey-700 px-3 py-2">
                <ThumbnailWithPreview
                    imageUrl={imageUrl}
                    name={displayName}
                    fallbackIcon={
                        <CarIcon className="text-grey-300" size={28} />
                    }
                />
                <div className="min-w-0 flex-1">
                    <p className="truncate text-sm-medium text-white-100">
                        {displayName}
                    </p>
                    <span className="mt-0.5 inline-block rounded bg-grey-500 px-1.5 py-0.5 font-mono text-xs text-grey-200">
                        {vehicle.licensePlate}
                    </span>
                </div>
            </div>
        </div>
    );
}
